import { QueryExpressionMap } from '@sierralabs/query-core';
import { useCallback, useMemo } from 'react';
import { useApiPost } from '../../api/Api.hooks';

export function useRunQuery<T = any>() {
  const { data, isLoading, error, post } = useApiPost<T>('queries/run');

  const runQuery = useCallback(
    (expressionMap: QueryExpressionMap) => {
      post({ expressionMap });
    },
    [post]
  );
  const runPaginatedQuery = useCallback(
    (expressionMap: QueryExpressionMap) => {
      post({ expressionMap, returnType: 'paginated' });
    },
    [post]
  );
  const runQueryGetOne = useCallback(
    (expressionMap: QueryExpressionMap) => {
      post({ expressionMap, returnType: 'one' });
    },
    [post]
  );
  // clean up postgres string arrays that are quote qualified
  const queryData = useMemo(() => {
    if (Array.isArray(data)) {
      for (const item of data) {
        removeQuotes(item);
      }
    } else if (data && typeof data === 'object') {
      removeQuotes(data);
    }
    return data;
  }, [data]);
  return {
    queryData,
    isRunningQuery: isLoading,
    runQueryError: error,
    runQuery,
    runPaginatedQuery,
    runQueryGetOne
  };
}

function removeQuotes(object: any) {
  const keys = Object.keys(object);
  for (const key of keys) {
    const item = object[key];
    if (Array.isArray(item)) {
      for (let i = 0; i < item.length; i++) {
        if (typeof item[i] === 'string') {
          item[i] = item[i].replace(/"/g, '');
        }
      }
    }
  }
}
